module.exports = __webpack_public_path__ + "static/team-23-7ce1ea833c5247ce573859717d09fed0.jpg";